export class ContractLot {
   id: string;
   documentTypeEnterpriseId: string;
   enterpriseSign: any[];
   userSign: any[];
   signatures: any[];
   importFileBase64: string;
   importFileName: string;
   contractDetails: any;
   resultFilePath: string;
   code: string;
   contentDetails: string;
  maxPartnerNumber: number;
  contractSharePartners: any[];
  type?: string;

   public static build(): ContractLot {
      const contractLot: ContractLot = new ContractLot();
      contractLot.id = null;
      contractLot.documentTypeEnterpriseId = null;
      contractLot.userSign = null;
      contractLot.signatures = null;
      contractLot.enterpriseSign = null;
      contractLot.importFileName = null;
      contractLot.importFileBase64 = null;
      contractLot.contractDetails = null;
      contractLot.resultFilePath = null;
      contractLot.maxPartnerNumber = 1;
      return contractLot;
   }
}
